import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditReportNameModal = ({ show, handleClose, report, onSave }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (report) {
      setName(report.name || '');
    }
  }, [report]);

  const handleSave = () => {
    // Ensure all fields are preserved
    const updatedReport = {
      ...report,
      name: name,
      data: report.data || [],
      customer_id: report.customer_id || null,
    };
    onSave(updatedReport);
    handleClose();
    toast.success('Report name updated successfully!', { position: "bottom-left" });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Report Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formReportName">
            <Form.Label>Report Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter report name"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditReportNameModal;
